var _rect, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1192_6425",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.351807,
    y: 0.148148,
    width: 40,
    height: 40,
    rx: 14,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1192_6425)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.351807,
    y: 0.148148,
    width: 40,
    height: 40,
    fill: "#E60052"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1355 22.9783C24.8268 22.6393 24.3018 22.6148 23.9629 22.9234L21.5207 25.1471V12.9782C21.5207 12.5198 21.1491 12.1481 20.6906 12.1481C20.2322 12.1481 19.8606 12.5198 19.8606 12.9782V25.1471L17.4184 22.9234C17.0794 22.6148 16.5544 22.6393 16.2458 22.9783C15.9372 23.3173 15.9617 23.8423 16.3007 24.1509L20.6906 28.1481L25.0806 24.1509C25.4196 23.8423 25.4441 23.3173 25.1355 22.9783Z",
    fill: "#E60052"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDown);
export default __webpack_public_path__ + "static/media/icDown.6e8ba4f684e750facbfdafe082158c90.svg";
export { ForwardRef as ReactComponent };